"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationDetails = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../lib/utils");
var _styles = require("./styles");
const LocationDetails = _ref => {
  let {
    location,
    provider,
    appointment
  } = _ref;
  const videoPhoneAppointment = (0, _utils.hasAnyVideoPhoneAppt)(appointment.visit_method);
  const street1 = location.street1;
  const street2 = location.street2 ? `, ${location.street2}` : '';
  const suite = location.suite ? `, ${location.suite}` : '';
  return /*#__PURE__*/_react.default.createElement(_styles.ApptDetailsRow, null, /*#__PURE__*/_react.default.createElement(_styles.ProviderName, null, (0, _utils.formatProviderName)(provider)), videoPhoneAppointment && /*#__PURE__*/_react.default.createElement("p", null, appointment.name), !videoPhoneAppointment && /*#__PURE__*/_react.default.createElement(_styles.Address, null, location.name && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, location.name, /*#__PURE__*/_react.default.createElement("br", null)), `${street1}${street2}${suite}`, /*#__PURE__*/_react.default.createElement("br", null), `${location.city}, ${location.state}, ${location.zip}`));
};
exports.LocationDetails = LocationDetails;
LocationDetails.propTypes = {
  appointment: _propTypes.default.object.isRequired,
  location: _propTypes.default.object.isRequired,
  provider: _propTypes.default.object.isRequired
};
LocationDetails.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LocationDetails",
  "props": {
    "appointment": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "location": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "provider": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    }
  }
};